import Api from '@/services/Api'

export default {
  getProducts () {
    return Api().post('', {
      command: 'GetProducts'})
  },
  getProductsBezOst () {
    return Api().post('', {
      command: 'GetProductsBezOst'})
  },
  getProductsFile () {
    return Api().post('', {
      command: 'GetProductsFile'})
  },
  getPricesFile () {
    return Api().post('', {
      command: 'GetPricesFile'})
  },
  getManagersFile () {
    return Api().post('', {
      command: 'GetManagersFile'})
  },
  getContragentsFile () {
    return Api().post('', {
      command: 'GetContragentsFile'})
  },
  getStockFile () {
    return Api().post('', {
      command: 'GetStockFile'})
  },
  getBalanceFile () {
    return Api().post('', {
      command: 'GetBalanceFile'})
  },
  getContragentInvoices (unp) {
    return Api().post('', {
      command: 'GetContragentInvoices',
      UNP: unp})
  },
  getContragentsInvoices () {
    return Api().post('', {
      command: 'GetContragentsInvoices'
    })
  },
  getLoginLog () {
    return Api().post('', {
      command: 'GetLoginLog'
    })
  },
  writeErrorLog (data) {
    return Api().post('', {
      command: 'WriteErrorLog',
      Data: data})
  },
  getOrderFile (unp) {
    return Api().post('', {
      command: 'GetOrderFile',
      UNP: unp})
  },
  getB2BOrdersList () {
    return Api().post('', {
      command: 'GetB2BOrdersList'})
  },
  getRemindersList () {
    return Api().post('', {
      command: 'GetRemindersList'})
  },
  putOrderFile (unp, order) {
    return Api().post('', {
      command: 'PutOrderFile',
      UNP: unp,
      Order: order})
  },
  // sendOrderFile(this.selectedContragent.UNP, this.newcomment, this.selectedContragent.EmailDlyaRassylky, this.selectedContragentManager.EMail, JSON.stringify(this.user))
  sendOrderFile (unp, comment, contragentEmail, managerEmail, stats) {
    return Api().post('', {
      command: 'SendOrderFile',
      UNP: unp,
      comment: comment,
      contragentEmail: contragentEmail,
      managerEmail: managerEmail,
      Stats: stats
    })
  },
  sendReminder (unp, comment, contragentEmail, managerEmail) {
    return Api().post('', {
      command: 'SendReminder',
      UNP: unp,
      comment: comment,
      contragentEmail: contragentEmail,
      managerEmail: managerEmail
    })
  },
  readReminder (unp) {
    return Api().post('', {
      command: 'ReadReminder',
      UNP: unp})
  },
  deleteOrderFile (unp) {
    return Api().post('', {
      command: 'DeleteOrderFile',
      UNP: unp})
  },
  getCurrencyRates () {
    return Api().post('', {
      command: 'GetCurrencyRates'})
  },
  getInfotronicData () {
    return Api().post('', {
      command: 'GetInfotronicData'})
  },

  getInfotronicOrders () {
    return Api().post('', {
      command: 'GetInfotronicOrders'})
  },
  getInfotronic1C () {
    return Api().post('', {
      command: 'GetInfotronic1C'})
  },

  getOrdersStatus (unp) {
    return Api().post('', {
      command: 'GetOrdersStatus',
      UNP: unp})
  },
  getOrder (orderNumber) {
    return Api().post('', {
      command: 'GetOrder',
      OrderNumber: orderNumber})
  },
  getFavFile (unp) {
    return Api().post('', {
      command: 'GetFavFile',
      UNP: unp})
  },
  putFavFile (unp, favs) {
    return Api().post('', {
      command: 'PutFavFile',
      UNP: unp,
      Favs: favs})
  },
  getGoods (uid) {
    return Api().post('', {
      command: 'Goods',
      UID: uid})
  },
  getGoodsABCXYZ () {
    return Api().post('', {
      command: 'goodsABCXYZ'})
  },
  getPictureList () {
    return Api().post('', {
      command: 'GetPictureList'})
  },
  getPlan () {
    return Api().post('', {
      command: 'GetPlan'})
  },
  getBonus () {
    return Api().post('', {
      command: 'GetBonus'})
  },
  getGoodABCXYZ (uid) {
    return Api().post('', {
      command: 'goodABCXYZ',
      UID: uid})
  },
  getGoodsReserves () {
    return Api().post('', {
      command: 'goodsReserves'})
  },
  getGoodReserves (uid) {
    return Api().post('', {
      command: 'goodReserves',
      UID: uid})
  },
  getTransitOrder (filename) {
    return Api().post('', {
      command: 'getTransitOrder',
      filename: filename})
  },
  getInvoice (filename) {
    return Api().post('', {
      command: 'getInvoice',
      filename: filename})
  },
  deleteTransitOrder (filename) {
    return Api().post('', {
      command: 'deleteTransitOrder',
      filename: filename})
  },
  getGoodsToShipment () {
    return Api().post('', {
      command: 'goodsToShipment'})
  },
  getGoodToShipment (uid) {
    return Api().post('', {
      command: 'goodToShipment',
      UID: uid})
  },
  getGoodSelling (uid) {
    return Api().post('', {
      command: 'getGoodSelling',
      UID: uid})
  },
  getPriceSQ () {
    return Api().post('', {
      command: 'getPriceSQ'})
  },
  getSupplierInvoicesList () {
    return Api().post('', {
      command: 'getSupplierInvoicesList'})
  },
  goodsSalesByPeriod (startDate, endDate) {
    return Api().post('', {
      command: 'getGoodsSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  goodSalesByPeriod (UID, startDate, endDate) {
    return Api().post('', {
      command: 'getGoodSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate,
      UID: UID
    })
  },
  getDeliverySchemes () {
    return Api().post('', {
      command: 'deliverySchemes'})
  },
  getSupplierOrderList () {
    return Api().post('', {
      command: 'getSupplierOrderList'})
  },
  createSupplierOrder () {
    return Api().post('', {
      command: 'createSupplierOrder'})
  },
  getSupplierOrders () {
    return Api().post('', {
      command: 'getSupplierOrders'})
  },
  patchSupplierOrder (uid, jsonString, dataVersion) {
    return Api().post('', {
      command: 'patchSupplierOrder',
      orderId: uid,
      jsonString: jsonString,
      dataVersion: dataVersion })
  },
  getClientBalance (partnerId, days) {
    return Api().post('', {
      command: 'getClientBalance',
      partnerId: partnerId,
      days: days})
  },
  getContragents () {
    return Api().post('', {
      command: 'contragents'
    })
  },
  getOrderList (uid) {
    return Api().post('', {
      command: 'GetOrdersList',
      UID: uid})
  },
  auth (Login, Password) {
    return Api().post('', {
      command: 'Auth',
      Login: Login,
      Password: Password})
  },
  sendSiteLetter (name, phone, text) {
    return Api().post('', {
      command: 'SendLetter',
      Name: name,
      Phone: phone,
      Text: text
    })
  },
  getFolders () {
    return Api().post('', {
      command: 'folders'
    })
  },
  authMNG (uid, info) {
    return Api().post('', {
      command: 'AuthorizationMNG',
      UID: uid,
      info: info})
  },
  partnerABCXYZ (uid) {
    return Api().post('', {
      command: 'partnerABCXYZ',
      UID: uid})
  },
  managers () {
    return Api().post('', {
      command: 'getManagers'
    })
  },
  partnersABCXYZ () {
    return Api().post('', {
      command: 'partnersABCXYZ'
    })
  },
  partnersSalesByPeriod (startDate, endDate) {
    return Api().post('', {
      command: 'getPartnersSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  partnersSalesByPeriodShort (startDate, endDate) {
    return Api().post('', {
      command: 'getPartnersSalesByPeriodShort',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  partnersSalesByYear (year) {
    return Api().post('', {
      command: 'getPartnersSalesByYear',
      Year: year })
  },
  managersSalesByYear (year) {
    return Api().post('', {
      command: 'getManagersSalesByYear',
      Year: year })
  },
  partnerSalesByYear (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYear',
      UID: uid,
      Year: year })
  },
  partnerSalesByYearByGoods (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYearByGoods',
      UID: uid,
      Year: year })
  },
  partnersSalesByYearByGoods (year) {
    return Api().post('', {
      command: 'getPartnersSalesByYearByGoods',
      Year: year })
  },
  partnerSalesByYearByGroups (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYearByGroups',
      UID: uid,
      Year: year })
  },
  createOrder (partnerId, contragentId, agreement) {
    return Api().post('', {
      command: 'createOrder',
      partnerId: partnerId,
      contragentId: contragentId,
      agreement: agreement})
  },
  patchOrder (Id, String, Version) {
    return Api().post('', {
      command: 'patchOrder',
      orderId: Id,
      jsonString: String,
      dataVersion: Version})
  },
  postOrder (orderId, comm, message, Version, maxline) {
    return Api().post('', {
      command: 'setOrderPosted',
      orderId: orderId,
      message: message,
      comment: comm,
      dataVersion: Version,
      maxline: maxline })
  },
  changeArticle (code, article) {
    return Api().post('', {
      command: 'changeArticle',
      Code: code,
      Article: article
    })
  },
  writePercent (percent) {
    return Api().post('', {
      command: 'writePercent',
      percent: percent
    })
  },
  writeSpecialOrderFile (UNP, orderfile) {
    return Api().post('', {
      command: 'WriteSpecialOrderFile',
      UNP: UNP,
      orderfile: orderfile
    })
  },
  writeQuiz (UNP, orderfile) {
    return Api().post('', {
      command: 'WriteQuiz',
      UNP: UNP,
      orderfile: orderfile
    })
  },
  writeSpecialOrderFileManager (UNP, orderfile) {
    return Api().post('', {
      command: 'WriteSpecialOrderFileManager',
      UNP: UNP,
      orderfile: orderfile
    })
  },
  readSpecialOrderFile (UNP) {
    return Api().post('', {
      command: 'ReadSpecialOrderFile',
      UNP: UNP
    })
  },
  readQuizFile (UNP) {
    return Api().post('', {
      command: 'ReadQuizFile',
      UNP: UNP
    })
  },
  getContragentsMailFile () {
    return Api().post('', {
      command: 'GetContragentsMailFile'

    })
  },

  readSpecialOrderFileManager (UNP) {
    return Api().post('', {
      command: 'ReadSpecialOrderFileManager',
      UNP: UNP
    })
  },
  readSpecialOrderSyncFile (UNP) {
    return Api().post('', {
      command: 'ReadSpecialOrderSyncFile',
      UNP: UNP
    })
  },
  writeSpecialOrderSyncFile (UNP, orderfile) {
    return Api().post('', {
      command: 'WriteSpecialOrderSyncFile',
      UNP: UNP,
      orderfile: orderfile
    })
  },
  sendTelegramNotification (manager, message) {
    return Api().post('', {
      command: 'SendTelegramNotification',
      manager: manager,
      message: message
    })
  },
  getSpecialOrdersList () {
    return Api().post('', {
      command: 'GetSpecialOrdersList'

    })
  },
  getQuizList () {
    return Api().post('', {
      command: 'GetQuizList'

    })
  },

  getSpecialOrdersSyncList () {
    return Api().post('', {
      command: 'GetSpecialOrdersSyncList'

    })
  },

  getSpecialOrdersListManager () {
    return Api().post('', {
      command: 'GetSpecialOrdersListManager'

    })
  },
  getSkorpionoCatalog (uid) {
    return Api().post('', {
      command: 'getSkorpionoFolders',
      UID: uid
    })
  },
  getSkorpionoPictures () {
    return Api().post('', {
      command: 'getSkorpionoPictures'
    })
  },
  getExchangeRate () {
    return Api().post('', {
      command: 'getExchangeRate'
    })
  },
  getExchangeRateUSD () {
    return Api().post('', {
      command: 'getExchangeRateUSD'
    })
  },
  createGood (article, description) {
    return Api().post('', {
      command: 'createGood',
      article: article,
      description: description
    })
  },
  getAlfaStatement (startDate, endDate) {
    return Api().post('', {
      command: 'getAlfaStatement',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  createConversation (partnerUid, partnerName, managerUid, phone, tag, message) {
    return Api().post('', {
      command: 'createConversation',
      partner_uid: partnerUid,
      partner_name: partnerName,
      manager_uid: managerUid,
      phone: phone,
      tag: tag,
      message: message
    })
  },
  getPhone (partnerUid) {
    return Api().post('', {
      command: 'getPhone',
      partner_uid: partnerUid
    })
  },
  getPhoneCalls () {
    return Api().post('', {
      command: 'getPhoneCalls'
    })
  },
  getBusinessRegions () {
    return Api().post('', {
      command: 'getBusinessRegions'
    })
  },
  getTransit () {
    return Api().post('', {
      command: 'getTransit'
    })
  },
  getPartnersSalesByDate (EndDate) {
    return Api().post('', {
      command: 'getPartnersSalesByDate',
      EndDate: EndDate
    })
  },
  getPartnersPayments () {
    return Api().post('', {
      command: 'getPartnersPayments'
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js